import * as e from "react";
import { Fragment as t, jsx as n, jsxs as r } from "react/jsx-runtime";
// src/forms/Button.tsx
function i({ children: t, variant: r = "default", size: i = "md", full: a = !1, disabled: o = !1, onClick: s, style: c = {}, type: l = "button", ...u }) {
	let d = i === "sm" ? "5px 10px" : "7px 12px", [f, p] = e.useState(!1);
	return r === "gold" ? /* @__PURE__ */ n("button", {
		type: l,
		onClick: o ? void 0 : s,
		disabled: o,
		onMouseEnter: () => p(!0),
		onMouseLeave: () => p(!1),
		style: {
			font: "inherit",
			fontSize: "var(--fs-xs)",
			fontFamily: "var(--font-sans)",
			fontWeight: "var(--fw-bold)",
			letterSpacing: "var(--ls-label)",
			textTransform: "uppercase",
			color: o ? "var(--text-dim)" : "#0a0805",
			background: o ? "var(--surface-btn)" : "var(--grad-gold)",
			border: "none",
			borderRadius: "var(--radius)",
			padding: d,
			cursor: o ? "not-allowed" : "pointer",
			width: a ? "100%" : "auto",
			opacity: o ? .55 : 1,
			filter: f && !o ? "brightness(1.08)" : "none",
			transition: "filter var(--dur-fast)",
			...c
		},
		...u,
		children: t
	}) : /* @__PURE__ */ n("button", {
		type: l,
		onClick: o ? void 0 : s,
		disabled: o,
		onMouseEnter: () => p(!0),
		onMouseLeave: () => p(!1),
		style: {
			font: "inherit",
			fontSize: "var(--fs-xs)",
			fontFamily: "var(--font-sans)",
			color: o ? "var(--text-faint)" : f && r === "accent" ? "var(--accent-hi)" : r === "accent" ? "var(--accent)" : r === "muted" ? "var(--text-muted)" : "var(--text)",
			background: "var(--surface-btn)",
			border: "1px solid " + (o ? "var(--border)" : f ? r === "accent" ? "var(--accent)" : "var(--border-hover)" : "var(--border)"),
			borderRadius: "var(--radius)",
			padding: d,
			cursor: o ? "not-allowed" : "pointer",
			width: a ? "100%" : "auto",
			transition: "border-color var(--dur-fast), color var(--dur-fast)",
			...c
		},
		...u,
		children: t
	});
}
// src/forms/DiamondCheckbox.tsx
function a({ checked: e = !1, color: t = "var(--accent)", size: r = 15, onChange: i, "aria-label": a = "Toggle complete" }) {
	return /* @__PURE__ */ n("button", {
		type: "button",
		onClick: i,
		"aria-checked": e,
		role: "checkbox",
		"aria-label": a,
		style: {
			width: r,
			height: r,
			flexShrink: 0,
			cursor: "pointer",
			padding: 0,
			border: "1.5px solid " + (e ? t : "var(--border-hover)"),
			background: e ? t : "transparent",
			borderRadius: 0,
			transform: "rotate(45deg)",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			transition: "border-color var(--dur-fast), background var(--dur-fast)"
		},
		children: /* @__PURE__ */ n("span", {
			"aria-hidden": "true",
			style: {
				transform: "rotate(-45deg)",
				fontSize: r * .6,
				lineHeight: 1,
				color: "var(--bg-base)",
				fontWeight: 700,
				fontFamily: "var(--font-sans)"
			},
			children: e ? "✓" : ""
		})
	});
}
// src/forms/SearchField.tsx
function o({ placeholder: t = "Search objects", kbd: i = "CTRL SPACE", value: a, onChange: o, width: s = 230, "aria-label": c = "Search" }) {
	let [l, u] = e.useState(!1);
	return /* @__PURE__ */ r("div", {
		style: {
			display: "flex",
			alignItems: "center",
			gap: 7,
			width: s,
			background: "var(--surface-3)",
			border: "1px solid " + (l ? "var(--accent)" : "var(--border)"),
			padding: "5px 10px",
			transition: "border-color var(--dur-fast)"
		},
		children: [
			/* @__PURE__ */ n("span", {
				className: "mn",
				"aria-hidden": "true",
				style: {
					color: "var(--text-ghost)",
					fontSize: 12,
					fontFamily: "var(--font-mono)"
				},
				children: "⌕"
			}),
			/* @__PURE__ */ n("input", {
				type: "search",
				"aria-label": c,
				value: a,
				placeholder: t,
				onFocus: () => u(!0),
				onBlur: () => u(!1),
				onChange: (e) => o && o(e.target.value),
				style: {
					flex: 1,
					minWidth: 0,
					background: "transparent",
					border: 0,
					outline: "none",
					color: "var(--text-hi)",
					font: "inherit",
					fontFamily: "var(--font-mono)",
					fontSize: "var(--fs-xs)",
					WebkitAppearance: "none",
					appearance: "none"
				}
			}),
			i && /* @__PURE__ */ n("span", {
				"aria-hidden": "true",
				style: {
					fontFamily: "var(--font-mono)",
					fontSize: "var(--fs-3xs)",
					color: "var(--text-ghost)",
					border: "1px solid var(--border-mute)",
					padding: "0 4px"
				},
				children: i
			})
		]
	});
}
// src/forms/TextField.tsx
function s({ label: t, value: i, onChange: a, type: o = "text", placeholder: s, disabled: c = !1, error: l, autoFocus: u = !1, name: d, onSubmit: f, full: p = !1 }) {
	let m = e.useId(), h = "tf-" + (d || t.toLowerCase().replace(/[^a-z0-9]+/g, "-") || m), g = h + "-error", [_, v] = e.useState(!1), [y, b] = e.useState(!1);
	return /* @__PURE__ */ r("div", {
		style: {
			display: "flex",
			flexDirection: "column",
			gap: 5,
			width: p ? "100%" : "auto"
		},
		children: [
			/* @__PURE__ */ n("label", {
				htmlFor: h,
				style: {
					fontFamily: "var(--font-mono)",
					fontSize: "var(--fs-2xs)",
					letterSpacing: "var(--ls-label)",
					textTransform: "uppercase",
					color: "var(--text-label)"
				},
				children: t
			}),
			/* @__PURE__ */ n("input", {
				id: h,
				name: d,
				type: o,
				value: i,
				placeholder: s,
				disabled: c,
				autoFocus: u,
				"aria-invalid": l ? !0 : void 0,
				"aria-describedby": l ? g : void 0,
				onFocus: () => v(!0),
				onBlur: () => v(!1),
				onMouseEnter: () => b(!0),
				onMouseLeave: () => b(!1),
				onChange: (e) => a && a(e.target.value),
				onKeyDown: (e) => {
					e.key === "Enter" && f && f();
				},
				style: {
					width: p ? "100%" : "auto",
					boxSizing: "border-box",
					background: "var(--well)",
					border: "1px solid " + (l ? "var(--alert-edge)" : _ ? "var(--accent)" : y && !c ? "var(--border-hover)" : "var(--border)"),
					borderRadius: "var(--radius)",
					color: c ? "var(--text-faint)" : "var(--text-hi)",
					fontFamily: "var(--font-sans)",
					fontSize: "var(--fs-body)",
					padding: "7px 10px",
					outline: "none",
					cursor: c ? "not-allowed" : "text",
					transition: "border-color var(--dur-fast)",
					WebkitAppearance: "none",
					appearance: "none"
				}
			}),
			l && /* @__PURE__ */ n("div", {
				id: g,
				style: {
					fontFamily: "var(--font-mono)",
					fontSize: "var(--fs-2xs)",
					letterSpacing: "var(--ls-label)",
					color: "var(--alert-2)"
				},
				children: l
			})
		]
	});
}
// src/forms/Select.tsx
function c({ label: t, value: i, onChange: a, options: o, placeholder: s, disabled: c = !1, name: l, full: u = !1, "aria-label": d }) {
	let f = e.useId(), p = "sel-" + (l || t?.toLowerCase().replace(/[^a-z0-9]+/g, "-") || f), [m, h] = e.useState(!1), [g, _] = e.useState(!1);
	return /* @__PURE__ */ r("div", {
		style: {
			display: "flex",
			flexDirection: "column",
			gap: 5,
			width: u ? "100%" : "auto"
		},
		children: [t && /* @__PURE__ */ n("label", {
			htmlFor: p,
			style: {
				fontFamily: "var(--font-mono)",
				fontSize: "var(--fs-2xs)",
				letterSpacing: "var(--ls-label)",
				textTransform: "uppercase",
				color: "var(--text-label)"
			},
			children: t
		}), /* @__PURE__ */ r("div", {
			style: {
				position: "relative",
				display: "flex",
				width: u ? "100%" : "auto"
			},
			onMouseEnter: () => _(!0),
			onMouseLeave: () => _(!1),
			children: [/* @__PURE__ */ r("select", {
				id: p,
				name: l,
				value: i ?? "",
				disabled: c,
				"aria-label": d ?? t,
				onFocus: () => h(!0),
				onBlur: () => h(!1),
				onChange: (e) => a?.(e.target.value),
				style: {
					appearance: "none",
					WebkitAppearance: "none",
					MozAppearance: "none",
					width: u ? "100%" : "auto",
					font: "inherit",
					fontFamily: "var(--font-sans)",
					fontSize: "var(--fs-body)",
					color: c ? "var(--text-faint)" : "var(--text-hi)",
					background: "var(--surface-btn)",
					border: "1px solid " + (m ? "var(--accent)" : g && !c ? "var(--border-hover)" : "var(--border)"),
					borderRadius: "var(--radius)",
					padding: "6px 30px 6px 11px",
					cursor: c ? "not-allowed" : "pointer",
					outline: "none",
					transition: "border-color var(--dur-fast)"
				},
				children: [s != null && /* @__PURE__ */ n("option", {
					value: "",
					disabled: !0,
					children: s
				}), o.map((e) => /* @__PURE__ */ n("option", {
					value: e.value,
					disabled: e.disabled,
					children: e.label
				}, e.value))]
			}), /* @__PURE__ */ n("span", {
				"aria-hidden": "true",
				style: {
					position: "absolute",
					right: 10,
					top: "50%",
					transform: "translateY(-50%)",
					fontFamily: "var(--font-mono)",
					fontSize: "var(--fs-2xs)",
					color: m ? "var(--accent)" : "var(--text-dim)",
					pointerEvents: "none"
				},
				children: "▾"
			})]
		})]
	});
}
// src/forms/VolumeControl.tsx
function l({ off: e, loud: i }) {
	return /* @__PURE__ */ r("svg", {
		width: "16",
		height: "16",
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		children: [/* @__PURE__ */ n("path", {
			d: "M4 9h3l4-3v12l-4-3H4z",
			fill: "currentColor"
		}), e ? /* @__PURE__ */ r(t, { children: [/* @__PURE__ */ n("line", {
			x1: "16",
			y1: "9",
			x2: "21",
			y2: "14",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		}), /* @__PURE__ */ n("line", {
			x1: "21",
			y1: "9",
			x2: "16",
			y2: "14",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		})] }) : /* @__PURE__ */ r(t, { children: [/* @__PURE__ */ n("path", {
			d: "M15 9a4 4 0 0 1 0 6",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		}), i && /* @__PURE__ */ n("path", {
			d: "M17.6 6.6a7.5 7.5 0 0 1 0 10.8",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		})] })]
	});
}
function u({ volume: e, muted: t, onVolumeChange: i, onMutedChange: a, label: o = "Volume", hideSlider: s = !1 }) {
	let c = Math.min(1, Math.max(0, e)), u = t ? 0 : c, d = Math.round(u * 100), f = (e) => {
		let n = Math.min(1, Math.max(0, e));
		i(n), n > 0 && t && a(!1);
	};
	return /* @__PURE__ */ r("div", {
		role: "group",
		"aria-label": o,
		style: {
			display: "inline-flex",
			alignItems: "center",
			gap: 8,
			padding: s ? "5px 7px" : "5px 11px 5px 7px",
			borderRadius: "var(--radius-pill)",
			background: "rgba(8, 8, 10, 0.62)",
			border: "1px solid var(--hairline)",
			backdropFilter: "blur(2px)"
		},
		children: [/* @__PURE__ */ n("button", {
			type: "button",
			"aria-label": t ? "Unmute" : "Mute",
			"aria-pressed": t,
			onClick: () => a(!t),
			style: {
				display: "inline-flex",
				alignItems: "center",
				justifyContent: "center",
				width: 24,
				height: 24,
				padding: 0,
				background: "transparent",
				border: "none",
				borderRadius: "var(--radius-sm)",
				color: t || c <= 0 ? "var(--text-dim)" : "var(--gold)",
				cursor: "pointer",
				transition: "color var(--dur-fast)"
			},
			children: /* @__PURE__ */ n(l, {
				off: t || c <= 0,
				loud: !t && c > .5
			})
		}), !s && /* @__PURE__ */ n("input", {
			className: "mer-volume__range",
			type: "range",
			min: 0,
			max: 1,
			step: .05,
			value: u,
			"aria-label": o,
			"aria-valuetext": t ? "Muted" : `${d}%`,
			onChange: (e) => f(Number(e.target.value)),
			style: {
				width: 96,
				background: `linear-gradient(to right, var(--gold) ${u * 100}%, var(--border-hover) ${u * 100}%)`
			}
		})]
	});
}
// src/navigation/IconRailItem.tsx
function d({ icon: t, label: i, active: a = !1, onClick: o }) {
	let [s, c] = e.useState(!1);
	return /* @__PURE__ */ r("button", {
		type: "button",
		title: i,
		"aria-label": i,
		"aria-pressed": a,
		onClick: o,
		onMouseEnter: () => c(!0),
		onMouseLeave: () => c(!1),
		style: {
			position: "relative",
			width: 26,
			height: 26,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			padding: 0,
			background: "transparent",
			fontFamily: "var(--font-mono)",
			fontSize: 14,
			cursor: "pointer",
			color: a || s ? "var(--accent)" : "var(--text-label)",
			border: "1px solid " + (a || s ? "var(--border-hover)" : "var(--border-subtle)"),
			transition: "color var(--dur-fast), border-color var(--dur-fast)"
		},
		children: [/* @__PURE__ */ n("span", {
			"aria-hidden": "true",
			style: {
				position: "absolute",
				left: -12,
				top: 4,
				bottom: 4,
				width: 2,
				background: a ? "var(--accent)" : "transparent"
			}
		}), t]
	});
}
// src/navigation/CaseTab.tsx
function f({ title: t, dotColor: i = "var(--accent)", active: a = !1, onClick: o }) {
	let [s, c] = e.useState(!1);
	return /* @__PURE__ */ r("button", {
		type: "button",
		"aria-pressed": a,
		onClick: o,
		onMouseEnter: () => c(!0),
		onMouseLeave: () => c(!1),
		style: {
			display: "flex",
			alignItems: "center",
			gap: 8,
			padding: "0 16px",
			height: "100%",
			border: 0,
			borderRight: "1px solid var(--border-strong)",
			borderTop: "2px solid " + (a ? "var(--accent)" : "transparent"),
			background: a ? "var(--surface-3)" : "transparent",
			font: "inherit",
			fontFamily: "var(--font-sans)",
			fontSize: "var(--fs-sm)",
			color: a || s ? "var(--text-hi)" : "var(--text-label)",
			cursor: "pointer"
		},
		children: [/* @__PURE__ */ n("span", {
			"aria-hidden": "true",
			style: {
				width: 8,
				height: 8,
				background: i,
				flexShrink: 0,
				transform: "rotate(45deg)"
			}
		}), /* @__PURE__ */ n("span", {
			style: { whiteSpace: "nowrap" },
			children: t
		})]
	});
}
// src/navigation/ViewTab.tsx
function p({ label: t, active: r = !1, onClick: i }) {
	let [a, o] = e.useState(!1);
	return /* @__PURE__ */ n("button", {
		type: "button",
		"aria-pressed": r,
		onClick: i,
		onMouseEnter: () => o(!0),
		onMouseLeave: () => o(!1),
		style: {
			border: 0,
			background: "transparent",
			cursor: "pointer",
			font: "inherit",
			fontFamily: "var(--font-sans)",
			fontSize: "var(--fs-body-2)",
			padding: "9px 13px 10px",
			borderBottom: "2px solid " + (r ? "var(--accent)" : "transparent"),
			color: r ? "var(--accent)" : a ? "var(--text-hi)" : "var(--text-label)"
		},
		children: t
	});
}
// src/navigation/NavItem.tsx
function m({ label: t, icon: i, active: a = !1, onClick: o, badge: s, disabled: c = !1 }) {
	let [l, u] = e.useState(!1), d = a || l && !c;
	return /* @__PURE__ */ r("button", {
		type: "button",
		"aria-current": a ? "page" : void 0,
		disabled: c,
		onClick: c ? void 0 : o,
		onMouseEnter: () => u(!0),
		onMouseLeave: () => u(!1),
		style: {
			position: "relative",
			display: "flex",
			alignItems: "center",
			gap: 10,
			width: "100%",
			textAlign: "left",
			font: "inherit",
			fontFamily: "var(--font-sans)",
			fontSize: "var(--fs-body-2)",
			padding: "8px 12px 8px 14px",
			border: 0,
			borderRadius: "var(--radius-sm)",
			cursor: c ? "not-allowed" : "pointer",
			background: a || l && !c ? "var(--surface-hover)" : "transparent",
			color: c ? "var(--text-ghost)" : d ? a ? "var(--accent)" : "var(--text-hi)" : "var(--text-label)",
			transition: "color var(--dur-fast), background var(--dur-fast)"
		},
		children: [
			/* @__PURE__ */ n("span", {
				"aria-hidden": "true",
				style: {
					position: "absolute",
					left: 0,
					top: 4,
					bottom: 4,
					width: 2,
					background: a ? "var(--accent)" : "transparent"
				}
			}),
			i != null && /* @__PURE__ */ n("span", {
				"aria-hidden": "true",
				style: {
					width: 16,
					display: "inline-flex",
					justifyContent: "center",
					fontFamily: "var(--font-mono)",
					fontSize: 13,
					color: d ? a ? "var(--accent)" : "var(--text-hi)" : "var(--text-dim)",
					flexShrink: 0
				},
				children: i
			}),
			/* @__PURE__ */ n("span", {
				style: {
					flex: 1,
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis"
				},
				children: t
			}),
			s != null && /* @__PURE__ */ n("span", {
				style: {
					fontFamily: "var(--font-mono)",
					fontSize: "var(--fs-3xs)",
					letterSpacing: "var(--ls-label)",
					color: "var(--text-dim)"
				},
				children: s
			})
		]
	});
}
// src/navigation/SidebarNav.tsx
function h({ sections: e }) {
	return /* @__PURE__ */ n("nav", {
		style: {
			display: "flex",
			flexDirection: "column",
			gap: 2
		},
		children: e.map((e, t) => /* @__PURE__ */ r("div", {
			style: { marginTop: t === 0 ? 0 : 14 },
			children: [e.title && /* @__PURE__ */ n("div", {
				style: {
					padding: "6px 12px 5px 14px",
					fontFamily: "var(--font-mono)",
					fontSize: "var(--fs-3xs)",
					letterSpacing: "var(--ls-label-wide)",
					textTransform: "uppercase",
					color: "var(--text-ghost)"
				},
				children: e.title
			}), e.items.map((e) => /* @__PURE__ */ n(m, { ...e }, e.label))]
		}, e.title ?? t))
	});
}
// src/archetypes/AppShell.tsx
function g({ brand: e, title: t, actions: i, sidebar: a, sidebarFooter: o, banner: s, children: c, sidebarWidth: l = 208 }) {
	return /* @__PURE__ */ r("div", {
		className: "mer-canvas",
		style: {
			height: "calc(100vh / var(--ui-zoom, 1))",
			display: "grid",
			gridTemplateRows: s ? "auto 42px 1fr" : "42px 1fr",
			background: "var(--bg-canvas-grad)",
			color: "var(--text-hi)",
			overflow: "hidden"
		},
		children: [
			s,
			/* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					alignItems: "center",
					gap: 16,
					borderBottom: "1px solid var(--border-strong)",
					padding: "0 16px"
				},
				children: [
					e && /* @__PURE__ */ n("div", {
						style: {
							display: "flex",
							alignItems: "center"
						},
						children: e
					}),
					t != null && /* @__PURE__ */ n("div", {
						style: {
							display: "flex",
							alignItems: "center",
							gap: 8,
							minWidth: 0
						},
						children: t
					}),
					/* @__PURE__ */ n("div", { style: { flex: 1 } }),
					i != null && /* @__PURE__ */ n("div", {
						style: {
							display: "flex",
							alignItems: "center",
							gap: 10
						},
						children: i
					})
				]
			}),
			/* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					overflow: "hidden",
					minHeight: 0
				},
				children: [/* @__PURE__ */ r("aside", {
					style: {
						width: l,
						flexShrink: 0,
						borderRight: "1px solid var(--border-strong)",
						background: "var(--bg-rail)",
						display: "flex",
						flexDirection: "column",
						overflow: "hidden"
					},
					children: [/* @__PURE__ */ n("div", {
						style: {
							flex: 1,
							overflowY: "auto",
							padding: "12px 8px"
						},
						children: a
					}), o != null && /* @__PURE__ */ n("div", {
						style: {
							borderTop: "1px solid var(--border-subtle)",
							padding: "10px 12px"
						},
						children: o
					})]
				}), /* @__PURE__ */ n("main", {
					style: {
						flex: 1,
						minWidth: 0,
						overflowY: "auto",
						padding: "24px 28px"
					},
					children: c
				})]
			})
		]
	});
}
// src/archetypes/FullscreenShell.tsx
function _(t) {
	let [n, r] = e.useState(!1);
	return e.useEffect(() => {
		if (!t || typeof window > "u" || typeof window.matchMedia != "function") {
			r(!1);
			return;
		}
		let e = window.matchMedia("(orientation: portrait)"), n = () => r(e.matches);
		return n(), e.addEventListener ? e.addEventListener("change", n) : e.addListener(n), () => {
			e.removeEventListener ? e.removeEventListener("change", n) : e.removeListener(n);
		};
	}, [t]), t && n;
}
function v({ title: t, onExit: i, status: a, rail: o, railWidth: s = 320, exitLabel: c = "Exit full screen", stackRailInPortrait: l = !1, children: u }) {
	let [d, f] = e.useState(!1), p = _(l && o != null);
	return e.useEffect(() => {
		if (!i) return;
		let e = (e) => {
			e.key === "Escape" && i();
		};
		return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
	}, [i]), /* @__PURE__ */ r("div", {
		role: "dialog",
		"aria-modal": "true",
		"aria-label": typeof t == "string" ? t : "Full screen",
		className: "mer-canvas",
		style: {
			position: "fixed",
			inset: 0,
			zIndex: 200,
			height: "calc(100vh / var(--ui-zoom, 1))",
			display: "flex",
			flexDirection: "column",
			background: "var(--bg-canvas-grad), var(--bg-base)",
			color: "var(--text-hi)",
			overflow: "hidden",
			animation: "cnFade var(--dur) var(--ease-out)"
		},
		children: [/* @__PURE__ */ r("div", {
			style: {
				display: "flex",
				alignItems: "center",
				gap: 14,
				flexShrink: 0,
				padding: "8px 16px",
				borderBottom: "1px solid var(--border-strong)",
				background: "var(--bg-rail)",
				backdropFilter: "var(--blur-nav)"
			},
			children: [
				/* @__PURE__ */ n("span", {
					style: {
						fontFamily: "var(--font-sans)",
						fontSize: "var(--fs-title)",
						fontWeight: 800,
						letterSpacing: "var(--ls-label)",
						textTransform: "uppercase",
						color: "var(--gold)",
						whiteSpace: "nowrap",
						overflow: "hidden",
						textOverflow: "ellipsis"
					},
					children: t
				}),
				a != null && /* @__PURE__ */ n("span", {
					style: {
						display: "flex",
						alignItems: "center",
						gap: 8
					},
					children: a
				}),
				/* @__PURE__ */ n("span", { style: { flex: 1 } }),
				i && /* @__PURE__ */ r("button", {
					type: "button",
					"aria-label": c,
					onClick: i,
					onMouseEnter: () => f(!0),
					onMouseLeave: () => f(!1),
					style: {
						display: "inline-flex",
						alignItems: "center",
						gap: 7,
						font: "inherit",
						fontFamily: "var(--font-sans)",
						fontSize: "var(--fs-xs)",
						letterSpacing: "var(--ls-label)",
						textTransform: "uppercase",
						color: d ? "var(--accent-hi)" : "var(--text-muted)",
						background: "var(--surface-btn)",
						border: "1px solid " + (d ? "var(--accent)" : "var(--border)"),
						borderRadius: "var(--radius)",
						padding: "6px 12px",
						cursor: "pointer",
						transition: "color var(--dur-fast), border-color var(--dur-fast)"
					},
					children: [/* @__PURE__ */ n("span", {
						"aria-hidden": !0,
						style: {
							fontSize: "var(--fs-body)",
							lineHeight: 1
						},
						children: "⤡"
					}), "Exit"]
				})
			]
		}), /* @__PURE__ */ r("div", {
			style: {
				display: "flex",
				flexDirection: p ? "column" : "row",
				flex: 1,
				minHeight: 0
			},
			children: [/* @__PURE__ */ n("main", {
				"aria-label": "Stage",
				style: {
					flex: 1,
					minWidth: 0,
					minHeight: p ? 0 : void 0,
					overflow: "auto",
					padding: 16,
					display: "flex",
					flexDirection: "column"
				},
				children: u
			}), o != null && /* @__PURE__ */ n("aside", {
				"aria-label": "Panel",
				style: {
					width: p ? "100%" : s,
					flexShrink: 0,
					maxHeight: p ? "42dvh" : void 0,
					borderLeft: p ? void 0 : "1px solid var(--border-strong)",
					borderTop: p ? "1px solid var(--border-strong)" : void 0,
					background: "var(--bg-rail)",
					overflowY: "auto",
					padding: "14px 14px 16px"
				},
				children: o
			})]
		})]
	});
}
// src/layout/Panel.tsx
var y = {
	quiet: {
		background: "var(--surface-quiet)",
		border: "1px solid var(--border-faint)"
	},
	base: {
		background: "var(--surface-2)",
		border: "1px solid var(--hairline)"
	},
	raised: {
		background: "var(--surface-raised)",
		border: "1px solid var(--border-mute)",
		boxShadow: "var(--shadow-raised)",
		position: "relative",
		overflow: "hidden"
	}
};
function b({ tier: e = "base", title: t, titleAside: i, children: a, style: o, className: s, "aria-label": c }) {
	return /* @__PURE__ */ r("section", {
		className: s,
		"aria-label": c,
		style: {
			borderRadius: "var(--radius-lg)",
			padding: 18,
			backdropFilter: "var(--blur-panel)",
			WebkitBackdropFilter: "var(--blur-panel)",
			...y[e],
			...o
		},
		children: [
			e === "raised" && /* @__PURE__ */ n("span", {
				"aria-hidden": !0,
				style: {
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					height: 1,
					background: "linear-gradient(90deg, transparent, var(--accent-glow), transparent)"
				}
			}),
			t != null && /* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					alignItems: "center",
					gap: 9,
					marginBottom: 14
				},
				children: [
					/* @__PURE__ */ n("span", {
						style: {
							fontFamily: "var(--font-sans)",
							fontSize: "var(--fs-2xs)",
							fontWeight: 600,
							color: "var(--gold)",
							textTransform: "uppercase",
							letterSpacing: "var(--ls-label-wider)",
							whiteSpace: "nowrap"
						},
						children: t
					}),
					/* @__PURE__ */ n("span", {
						"aria-hidden": !0,
						style: {
							flex: 1,
							height: 1,
							background: "linear-gradient(90deg, var(--border), transparent)"
						}
					}),
					i
				]
			}),
			a
		]
	});
}
// src/layout/StatGrid.tsx
function x({ items: e, columns: t, color: i = "var(--gold-2)" }) {
	let a = t ?? e.length;
	return /* @__PURE__ */ n("div", {
		role: "list",
		style: {
			display: "grid",
			gridTemplateColumns: `repeat(${Math.max(1, a)}, minmax(0, 1fr))`,
			border: "1px solid var(--border-faint)",
			borderRadius: "var(--radius-md)",
			overflow: "hidden"
		},
		children: e.map((e, t) => /* @__PURE__ */ r("div", {
			role: "listitem",
			style: {
				padding: "16px 10px",
				textAlign: "center",
				borderLeft: t % Math.max(1, a) === 0 ? "none" : "1px solid var(--border-faintest)"
			},
			children: [/* @__PURE__ */ n("div", {
				style: {
					fontFamily: "var(--font-display)",
					fontSize: "var(--fs-h1)",
					fontWeight: 600,
					lineHeight: 1,
					color: i,
					fontVariantNumeric: "tabular-nums",
					fontFeatureSettings: "\"tnum\" 1"
				},
				children: e.value
			}), /* @__PURE__ */ n("div", {
				style: {
					marginTop: 6,
					fontFamily: "var(--font-sans)",
					fontSize: "var(--fs-3xs)",
					fontWeight: 600,
					textTransform: "uppercase",
					letterSpacing: "var(--ls-label)",
					color: "var(--text-dim)"
				},
				children: e.label
			})]
		}, t))
	});
}
// src/data/Chip.tsx
function S({ children: e, color: t = "var(--text-label)", variant: r = "outline" }) {
	return r === "count" ? /* @__PURE__ */ n("span", {
		style: {
			fontFamily: "var(--font-mono)",
			fontSize: "var(--fs-2xs)",
			background: t,
			color: "var(--bg-base)",
			padding: "0 5px",
			fontWeight: 600
		},
		children: e
	}) : /* @__PURE__ */ n("span", {
		style: {
			fontFamily: "var(--font-mono)",
			fontSize: "var(--fs-3xs)",
			color: t,
			border: "1px solid var(--border-mute)",
			padding: "0 5px",
			whiteSpace: "nowrap"
		},
		children: e
	});
}
// src/data/ContextMark.tsx
function C({ color: e = "var(--accent)", shape: t = "diamond", size: r = 9 }) {
	let i = {
		width: r,
		height: r,
		background: e,
		flexShrink: 0,
		display: "inline-block"
	}, a = t === "dot" ? {
		...i,
		borderRadius: "50%"
	} : t === "square" ? i : {
		...i,
		transform: "rotate(45deg)"
	};
	return /* @__PURE__ */ n("span", {
		"aria-hidden": "true",
		style: a
	});
}
// src/data/EventBlock.tsx
function w({ title: t, time: i, color: a = "var(--accent)", tint: o, compact: s = !1, onClick: c, style: l = {} }) {
	let [u, d] = e.useState(!1);
	return /* @__PURE__ */ r("div", {
		onClick: c,
		role: c ? "button" : void 0,
		tabIndex: c ? 0 : void 0,
		onKeyDown: c ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), c());
		} : void 0,
		onMouseEnter: () => d(!0),
		onMouseLeave: () => d(!1),
		style: {
			background: o || a + "22",
			borderLeft: "2px solid " + a,
			padding: s ? "2px 9px" : "4px 9px",
			overflow: "hidden",
			cursor: "pointer",
			filter: u ? "brightness(1.2)" : "none",
			display: "flex",
			gap: 7,
			flexDirection: s ? "row" : "column",
			alignItems: s ? "baseline" : "flex-start",
			...l
		},
		children: [/* @__PURE__ */ n("span", {
			style: {
				fontSize: "var(--fs-sm-2)",
				fontWeight: 500,
				color: "var(--text-hi)",
				whiteSpace: "nowrap",
				overflow: "hidden",
				textOverflow: "ellipsis",
				minWidth: 0
			},
			children: t
		}), /* @__PURE__ */ n("span", {
			style: {
				fontFamily: "var(--font-mono)",
				fontSize: "var(--fs-2xs)",
				color: "var(--text-label)",
				whiteSpace: "nowrap",
				flexShrink: 0
			},
			children: i
		})]
	});
}
// src/data/LoadSparkline.tsx
function T({ points: e = [
	72,
	60,
	66,
	44,
	58,
	40,
	40,
	10
], baseline: t = 40, overloaded: i = !0, width: a = 300, height: o = 96, "aria-label": s }) {
	let c = a / (e.length - 1), l = e.length - 1;
	return /* @__PURE__ */ r("svg", {
		role: "img",
		"aria-label": s ?? "Commitment load vs baseline" + (i ? " — overloaded past baseline" : ""),
		viewBox: "0 0 " + a + " " + o,
		preserveAspectRatio: "none",
		style: {
			width: "100%",
			height: o,
			display: "block"
		},
		children: [
			/* @__PURE__ */ n("line", {
				x1: "0",
				y1: t,
				x2: a,
				y2: t,
				stroke: "var(--accent-dim)",
				strokeWidth: "1",
				strokeDasharray: "3 3"
			}),
			i && /* @__PURE__ */ n("polygon", {
				points: a * .78 + "," + t + " " + a * .89 + "," + t + " " + a + "," + e[l] + " " + a + "," + t,
				fill: "var(--alert-tint)"
			}),
			/* @__PURE__ */ n("polyline", {
				points: e.map((e, t) => (t * c).toFixed(1) + "," + e).join(" "),
				fill: "none",
				stroke: "var(--accent)",
				strokeWidth: "2",
				vectorEffect: "non-scaling-stroke"
			}),
			/* @__PURE__ */ n("circle", {
				cx: a,
				cy: e[l],
				r: "3.5",
				fill: i ? "var(--alert)" : "var(--accent)"
			})
		]
	});
}
// src/data/LegendHeadshot.tsx
function ee({ photo: t, name: r, initials: i, variant: a = "grid" }) {
	let [o, s] = e.useState(!1);
	return e.useEffect(() => {
		s(!1);
	}, [t]), t?.trim() && !o ? /* @__PURE__ */ n("img", {
		src: t,
		alt: r,
		onError: () => s(!0),
		style: {
			width: "100%",
			height: "100%",
			objectFit: "cover"
		}
	}) : a === "featured" ? /* @__PURE__ */ n("div", {
		"aria-label": `${r} initials`,
		style: {
			width: 72,
			height: 72,
			borderRadius: "50%",
			background: "linear-gradient(160deg, var(--stone-600), var(--stone-800))",
			border: "2px solid var(--gold)",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			fontFamily: "var(--font-display)",
			fontSize: 30,
			fontWeight: 700,
			color: "var(--gold)",
			boxShadow: "0 4px 12px rgba(0,0,0,0.4)"
		},
		children: i
	}) : /* @__PURE__ */ n("span", {
		"aria-label": `${r} initials`,
		style: {
			fontFamily: "var(--font-display)",
			fontSize: 32,
			fontWeight: 700,
			color: "var(--gold)",
			opacity: .85
		},
		children: i
	});
}
// src/data/NodePill.tsx
function E({ label: t, kind: i = "leaf", color: a = "var(--accent)", selected: o = !1, conflict: s = !1, count: c, onClick: l }) {
	let [u, d] = e.useState(!1), f = {
		root: {
			fill: "var(--accent-tint)",
			border: o ? "var(--accent-hi)" : "var(--accent)",
			lb: "var(--accent)",
			pad: "9px 14px",
			fs: "var(--fs-title)",
			fw: 700,
			tc: "var(--text-hi)"
		},
		branch: {
			fill: "var(--surface-3)",
			border: o ? "var(--accent)" : "var(--border)",
			lb: a,
			pad: "7px 11px",
			fs: "var(--fs-body-2)",
			fw: 600,
			tc: "var(--text-hi)"
		},
		leaf: {
			fill: s ? "var(--alert-tint)" : "var(--surface-1)",
			border: s ? "var(--alert-edge)" : o ? "var(--accent)" : "var(--border-subtle)",
			lb: "transparent",
			pad: "5px 10px",
			fs: "var(--fs-sm-2)",
			fw: 500,
			tc: s ? "var(--alert-2)" : "var(--text-2)"
		}
	}[i], p = s ? "var(--glow-alert)" : o ? "var(--glow-accent-ring)" : "none";
	return /* @__PURE__ */ r("div", {
		onClick: l,
		role: l ? "button" : void 0,
		tabIndex: l ? 0 : void 0,
		"aria-pressed": l ? o : void 0,
		onKeyDown: l ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), l());
		} : void 0,
		onMouseEnter: () => d(!0),
		onMouseLeave: () => d(!1),
		style: {
			display: "inline-flex",
			alignItems: "center",
			gap: 8,
			background: f.fill,
			borderTop: "1px solid " + (u ? "var(--accent)" : f.border),
			borderRight: "1px solid " + (u ? "var(--accent)" : f.border),
			borderBottom: "1px solid " + (u ? "var(--accent)" : f.border),
			borderLeft: i === "branch" ? "3px solid " + a : "1px solid " + (u ? "var(--accent)" : f.border),
			padding: f.pad,
			cursor: "pointer",
			whiteSpace: "nowrap",
			boxShadow: p
		},
		children: [
			i === "leaf" && /* @__PURE__ */ n("span", {
				"aria-hidden": "true",
				style: {
					width: 7,
					height: 7,
					background: s ? "var(--alert)" : a,
					flexShrink: 0,
					transform: s ? "rotate(45deg)" : "none",
					borderRadius: s ? 0 : "50%"
				}
			}),
			/* @__PURE__ */ n("span", {
				style: {
					fontSize: f.fs,
					fontWeight: f.fw,
					color: f.tc
				},
				children: t
			}),
			i === "branch" && c != null && /* @__PURE__ */ n(S, { children: c })
		]
	});
}
// src/data/OutlineRow.tsx
function D({ title: i, type: a = "task", depth: o = 0, color: s = "var(--accent)", expanded: c, hasChildren: l = !1, pct: u, due: d, dueColor: f = "var(--text-label)", owner: p, badge: m, checked: h = !1, onClick: g }) {
	let [_, v] = e.useState(!1), y = {
		area: {
			fs: "var(--fs-title)",
			fw: 700,
			col: "var(--text-hi)",
			markRadius: 0,
			markRot: "45deg",
			markBorder: "0",
			markBg: s
		},
		project: {
			fs: "var(--fs-body)",
			fw: 600,
			col: "var(--text)",
			markRadius: 0,
			markRot: "0deg",
			markBorder: "1.5px solid " + s,
			markBg: "transparent"
		},
		task: {
			fs: "var(--fs-body-2)",
			fw: 450,
			col: "var(--text-2)",
			markRadius: "50%",
			markRot: "0deg",
			markBorder: "1px solid var(--border-hover)",
			markBg: "var(--border-faint)"
		},
		sub: {
			fs: "var(--fs-sm)",
			fw: 400,
			col: "var(--text-muted)",
			markRadius: "50%",
			markRot: "0deg",
			markBorder: "1px solid var(--border-hover-2)",
			markBg: "var(--border-faint)"
		}
	}[a];
	return /* @__PURE__ */ r("div", {
		onClick: g,
		role: g ? "button" : void 0,
		tabIndex: g ? 0 : void 0,
		"aria-expanded": g && l ? !!c : void 0,
		onKeyDown: g ? (e) => {
			(e.key === "Enter" || e.key === " ") && (e.preventDefault(), g());
		} : void 0,
		onMouseEnter: () => v(!0),
		onMouseLeave: () => v(!1),
		style: {
			display: "grid",
			gridTemplateColumns: "1fr 96px 120px 88px",
			alignItems: "center",
			padding: "10px 26px 10px 0",
			borderBottom: "1px solid var(--border-faintest)",
			cursor: "pointer",
			background: _ ? "var(--surface-hover)" : a === "area" ? "var(--surface-1)" : "transparent"
		},
		children: [
			/* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					alignItems: "center",
					gap: 9,
					paddingLeft: 24 + o * 22,
					minWidth: 0
				},
				children: [
					/* @__PURE__ */ n("span", {
						"aria-hidden": "true",
						style: {
							fontFamily: "var(--font-mono)",
							width: 13,
							flexShrink: 0,
							color: "var(--text-dim)",
							fontSize: "var(--fs-xs)",
							textAlign: "center"
						},
						children: l ? c ? "▾" : "▸" : ""
					}),
					/* @__PURE__ */ n("span", {
						"aria-hidden": "true",
						style: {
							width: 9,
							height: 9,
							flexShrink: 0,
							borderRadius: y.markRadius,
							transform: "rotate(" + y.markRot + ")",
							background: h ? "var(--border-hover)" : y.markBg,
							border: y.markBorder
						}
					}),
					/* @__PURE__ */ n("span", {
						style: {
							fontSize: y.fs,
							fontWeight: y.fw,
							color: h ? "var(--text-dim)" : y.col,
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis"
						},
						children: i
					}),
					m && /* @__PURE__ */ n(S, {
						color: s,
						children: m
					})
				]
			}),
			/* @__PURE__ */ n("div", {
				style: {
					display: "flex",
					alignItems: "center",
					justifyContent: "flex-end",
					gap: 7
				},
				children: u != null && /* @__PURE__ */ r(t, { children: [/* @__PURE__ */ n("div", {
					"aria-hidden": "true",
					style: {
						width: 46,
						height: 4,
						background: "var(--border-faint)"
					},
					children: /* @__PURE__ */ n("div", { style: {
						width: u + "%",
						height: "100%",
						background: s
					} })
				}), /* @__PURE__ */ r("span", {
					style: {
						fontFamily: "var(--font-mono)",
						fontSize: "var(--fs-2xs)",
						color: "var(--text-muted)",
						width: 26,
						textAlign: "right"
					},
					children: [u, "%"]
				})] })
			}),
			/* @__PURE__ */ n("span", {
				style: {
					fontFamily: "var(--font-mono)",
					fontSize: "var(--fs-xs)",
					color: f,
					textAlign: "right"
				},
				children: d
			}),
			/* @__PURE__ */ n("div", {
				style: {
					display: "flex",
					justifyContent: "flex-end"
				},
				children: p && /* @__PURE__ */ n("span", {
					style: {
						width: 22,
						height: 22,
						background: s,
						color: "var(--bg-base)",
						fontSize: "var(--fs-2xs-2)",
						fontWeight: 700,
						display: "flex",
						alignItems: "center",
						justifyContent: "center"
					},
					children: p
				})
			})
		]
	});
}
// src/data/TaskRow.tsx
function O({ title: t, project: i, due: o, dueColor: s = "var(--text-label)", color: c = "var(--accent)", checked: l = !1, flagged: u = !1, tag: d, onToggle: f, onOpen: p }) {
	let [m, h] = e.useState(!1), g = p ? (e) => {
		(e.key === "Enter" || e.key === " ") && (e.preventDefault(), p());
	} : void 0;
	return /* @__PURE__ */ r("div", {
		onClick: p,
		onMouseEnter: () => h(!0),
		onMouseLeave: () => h(!1),
		style: {
			display: "flex",
			alignItems: "flex-start",
			gap: 11,
			padding: "9px 8px",
			cursor: "pointer",
			borderTop: "1px solid " + (m ? "var(--border)" : "transparent"),
			borderRight: "1px solid " + (m ? "var(--border)" : "transparent"),
			borderLeft: "1px solid " + (m ? "var(--border)" : "transparent"),
			borderBottom: "1px solid var(--border-faint)",
			background: m ? "var(--surface-hover)" : "transparent"
		},
		children: [
			/* @__PURE__ */ n("div", {
				style: { marginTop: 1 },
				onClick: (e) => {
					e.stopPropagation(), f && f();
				},
				children: /* @__PURE__ */ n(a, {
					checked: l,
					color: c,
					"aria-label": (l ? "Mark not done: " : "Mark done: ") + t
				})
			}),
			/* @__PURE__ */ r("div", {
				style: {
					flex: 1,
					minWidth: 0
				},
				children: [/* @__PURE__ */ n("div", {
					role: p ? "button" : void 0,
					tabIndex: p ? 0 : void 0,
					onKeyDown: g,
					style: {
						fontSize: "var(--fs-body)",
						color: l ? "var(--text-dim)" : "var(--text-hi)",
						textDecoration: l ? "line-through" : "none"
					},
					children: t
				}), /* @__PURE__ */ r("div", {
					style: {
						display: "flex",
						alignItems: "center",
						gap: 8,
						marginTop: 3
					},
					children: [i && /* @__PURE__ */ n("span", {
						style: {
							fontFamily: "var(--font-mono)",
							fontSize: "var(--fs-2xs)",
							color: "var(--text-dim)"
						},
						children: i
					}), d && /* @__PURE__ */ n(S, {
						color: c,
						children: d
					})]
				})]
			}),
			/* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					flexDirection: "column",
					alignItems: "flex-end",
					gap: 3,
					flexShrink: 0
				},
				children: [/* @__PURE__ */ n("span", {
					style: {
						fontFamily: "var(--font-mono)",
						fontSize: "var(--fs-xs)",
						color: l ? "var(--text-dim)" : s
					},
					children: o
				}), u && !l && /* @__PURE__ */ n("span", {
					"aria-hidden": "true",
					style: {
						fontSize: "var(--fs-3xs)",
						color: "var(--ctx-vtx)"
					},
					children: "◆"
				})]
			})
		]
	});
}
// src/feedback/ConflictBanner.tsx
var k = {
	position: "absolute",
	width: 1,
	height: 1,
	padding: 0,
	margin: -1,
	overflow: "hidden",
	clip: "rect(0 0 0 0)",
	whiteSpace: "nowrap",
	border: 0
};
function A({ count: t = 6, time: i = "10:00 – 11:30", hint: a = "pick one ↔", onClick: o, style: s = {} }) {
	let [c, l] = e.useState(!1);
	return /* @__PURE__ */ r("div", {
		role: "button",
		tabIndex: 0,
		onClick: o,
		onKeyDown: (e) => {
			o && (e.key === "Enter" || e.key === " ") && (e.preventDefault(), o());
		},
		onMouseEnter: () => l(!0),
		onMouseLeave: () => l(!1),
		style: {
			position: "relative",
			cursor: "pointer",
			filter: c ? "brightness(1.15)" : "none",
			...s
		},
		children: [
			/* @__PURE__ */ n("div", { style: {
				position: "absolute",
				inset: 0,
				background: "var(--alert-well-3)",
				borderLeft: "2px solid var(--alert)",
				transform: "translate(6px,6px)"
			} }),
			/* @__PURE__ */ n("div", { style: {
				position: "absolute",
				inset: 0,
				background: "var(--alert-well-2)",
				borderLeft: "2px solid var(--alert)",
				transform: "translate(3px,3px)"
			} }),
			/* @__PURE__ */ r("div", {
				style: {
					position: "relative",
					background: "var(--alert-well)",
					borderLeft: "2px solid var(--alert)",
					padding: "6px 10px"
				},
				children: [/* @__PURE__ */ r("div", {
					style: {
						display: "flex",
						alignItems: "center",
						gap: 6
					},
					children: [
						/* @__PURE__ */ n("span", {
							style: {
								fontSize: "var(--fs-sm-2)",
								fontWeight: 600,
								color: "var(--alert-hi)"
							},
							children: "Conflict"
						}),
						/* @__PURE__ */ n(S, {
							variant: "count",
							color: "var(--alert)",
							children: t
						}),
						/* @__PURE__ */ n("span", {
							style: k,
							children: " events"
						})
					]
				}), /* @__PURE__ */ r("div", {
					style: {
						fontFamily: "var(--font-mono)",
						fontSize: "var(--fs-2xs)",
						color: "#e0a091",
						marginTop: 3
					},
					children: [
						i,
						" · ",
						a
					]
				})]
			})
		]
	});
}
// src/feedback/ConflictPicker.tsx
function j({ title: t = "Conflict window · 6 objects", subtitle: i = "WED 10:00–11:30 · resolve to clear the hotspot", events: a = [], onClose: o, onPick: s }) {
	return e.useEffect(() => {
		if (!o) return;
		let e = (e) => {
			e.key === "Escape" && o();
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [o]), /* @__PURE__ */ n("div", {
		onClick: o,
		style: {
			position: "absolute",
			inset: 0,
			background: "rgba(3,5,8,0.6)",
			zIndex: 40,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			animation: "cnFade var(--dur-fast) ease"
		},
		children: /* @__PURE__ */ r("div", {
			role: "dialog",
			"aria-modal": "true",
			"aria-label": t,
			onClick: (e) => e.stopPropagation(),
			style: {
				width: 540,
				maxHeight: "80%",
				background: "var(--surface-2)",
				border: "1px solid var(--border-hover-2)",
				boxShadow: "var(--shadow-modal)",
				overflow: "hidden",
				animation: "cnPop var(--dur) ease",
				display: "flex",
				flexDirection: "column"
			},
			children: [/* @__PURE__ */ r("div", {
				style: {
					padding: "16px 20px",
					borderBottom: "1px solid var(--border)",
					display: "flex",
					alignItems: "center",
					gap: 11,
					background: "var(--alert-tint)"
				},
				children: [
					/* @__PURE__ */ n("span", { style: {
						width: 9,
						height: 9,
						background: "var(--alert)",
						transform: "rotate(45deg)"
					} }),
					/* @__PURE__ */ r("div", {
						style: { flex: 1 },
						children: [/* @__PURE__ */ n("div", {
							style: {
								fontSize: "var(--fs-lg)",
								fontWeight: 700
							},
							children: t
						}), /* @__PURE__ */ n("div", {
							style: {
								fontFamily: "var(--font-mono)",
								fontSize: "var(--fs-xs)",
								color: "var(--text-label)"
							},
							children: i
						})]
					}),
					/* @__PURE__ */ n("button", {
						type: "button",
						"aria-label": "Close",
						onClick: o,
						style: {
							border: 0,
							background: "transparent",
							color: "var(--text-dim)",
							cursor: "pointer",
							fontSize: 20
						},
						children: "×"
					})
				]
			}), /* @__PURE__ */ n("div", {
				style: { overflowY: "auto" },
				children: a.map((e, t) => /* @__PURE__ */ n(M, {
					event: e,
					onPick: () => s && s(e, t)
				}, t))
			})]
		})
	});
}
function M({ event: t, onPick: a }) {
	let [o, s] = e.useState(!1);
	return /* @__PURE__ */ r("div", {
		onMouseEnter: () => s(!0),
		onMouseLeave: () => s(!1),
		style: {
			display: "flex",
			alignItems: "center",
			gap: 13,
			padding: "13px 20px",
			borderBottom: "1px solid var(--border-strong)",
			cursor: "pointer",
			background: o ? "var(--surface-hover-2)" : "transparent"
		},
		children: [
			/* @__PURE__ */ n("div", { style: {
				width: 10,
				height: 10,
				background: t.color,
				transform: "rotate(45deg)",
				flexShrink: 0
			} }),
			/* @__PURE__ */ r("div", {
				style: {
					flex: 1,
					minWidth: 0
				},
				children: [/* @__PURE__ */ n("div", {
					style: {
						fontSize: "var(--fs-body)",
						fontWeight: 500
					},
					children: t.title
				}), /* @__PURE__ */ n("div", {
					style: {
						fontFamily: "var(--font-mono)",
						fontSize: "var(--fs-xs-2)",
						color: "var(--text-label)",
						marginTop: 2
					},
					children: t.meta
				})]
			}),
			/* @__PURE__ */ r("div", {
				style: {
					textAlign: "right",
					flexShrink: 0
				},
				children: [/* @__PURE__ */ n("div", {
					style: {
						fontFamily: "var(--font-mono)",
						fontSize: "var(--fs-xs)",
						color: "var(--text)"
					},
					children: t.time
				}), /* @__PURE__ */ n("div", {
					style: {
						fontFamily: "var(--font-mono)",
						fontSize: "var(--fs-2xs-2)",
						color: t.priColor,
						marginTop: 2,
						fontWeight: 600
					},
					children: t.priority
				})]
			}),
			/* @__PURE__ */ n(i, {
				variant: "accent",
				size: "sm",
				onClick: a,
				"aria-label": `Attend ${t.title}`,
				children: "Attend"
			})
		]
	});
}
// src/feedback/ConfirmDialog.tsx
function N({ title: t, children: a, confirmLabel: o = "Confirm", cancelLabel: s = "Cancel", destructive: c = !1, busy: l = !1, error: u, onConfirm: d, onCancel: f }) {
	let p = e.useRef(null);
	return e.useEffect(() => {
		let e = (e) => {
			e.key === "Escape" && f();
		};
		return document.addEventListener("keydown", e), p.current?.querySelector("button")?.focus(), () => document.removeEventListener("keydown", e);
	}, [f]), /* @__PURE__ */ n("div", {
		onClick: f,
		style: {
			position: "fixed",
			inset: 0,
			background: "rgba(3,5,8,0.66)",
			zIndex: 60,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			padding: 20,
			animation: "cnFade var(--dur-fast) ease"
		},
		children: /* @__PURE__ */ r("div", {
			ref: p,
			role: "dialog",
			"aria-modal": "true",
			"aria-label": t,
			onClick: (e) => e.stopPropagation(),
			onKeyDown: (e) => {
				if (e.key !== "Tab") return;
				let t = p.current?.querySelectorAll("button:not([disabled])");
				if (!t || t.length === 0) return;
				let n = t[0], r = t[t.length - 1], i = document.activeElement;
				e.shiftKey && i === n ? (e.preventDefault(), r.focus()) : !e.shiftKey && i === r && (e.preventDefault(), n.focus());
			},
			style: {
				width: 460,
				maxWidth: "100%",
				background: "var(--surface-raised)",
				border: "1px solid var(--border-mute)",
				borderRadius: "var(--radius-lg)",
				boxShadow: "var(--shadow-modal)",
				overflow: "hidden",
				animation: "cnPop var(--dur) ease"
			},
			children: [
				/* @__PURE__ */ n("div", {
					style: { padding: "18px 20px 6px" },
					children: /* @__PURE__ */ n("h2", {
						style: {
							margin: 0,
							fontFamily: "var(--font-display)",
							fontSize: "var(--fs-h3)",
							fontWeight: 600,
							color: c ? "var(--alert-2)" : "var(--gold-2)"
						},
						children: t
					})
				}),
				/* @__PURE__ */ r("div", {
					style: {
						padding: "0 20px 16px",
						fontSize: "var(--fs-body)",
						color: "var(--text-prose)",
						lineHeight: 1.5
					},
					children: [a, u != null && /* @__PURE__ */ n("p", {
						role: "alert",
						style: {
							margin: "14px 0 0",
							padding: "9px 12px",
							borderRadius: "var(--radius-md)",
							border: "1px solid var(--alert)",
							background: "var(--alert-tint)",
							color: "var(--alert-2)",
							fontSize: "var(--fs-body-2)"
						},
						children: u
					})]
				}),
				/* @__PURE__ */ r("div", {
					style: {
						display: "flex",
						justifyContent: "flex-end",
						gap: 10,
						padding: "12px 20px",
						borderTop: "1px solid var(--border)",
						background: "var(--surface-2)"
					},
					children: [/* @__PURE__ */ n(i, {
						variant: "muted",
						disabled: l,
						onClick: f,
						children: s
					}), /* @__PURE__ */ n(i, {
						variant: c ? "default" : "accent",
						disabled: l,
						onClick: d,
						style: c ? {
							borderColor: "var(--alert)",
							color: "var(--alert-2)"
						} : void 0,
						children: l ? "Working…" : o
					})]
				})
			]
		})
	});
}
// src/feedback/InspectorCard.tsx
function P({ title: e, kind: t, meta: a, color: o = "var(--accent)", actionLabel: s = "Open object", onAction: c, onClose: l, style: u = {} }) {
	return /* @__PURE__ */ r("div", {
		role: "group",
		"aria-label": e,
		style: {
			width: 300,
			background: "var(--surface-2)",
			border: "1px solid var(--border-hover)",
			boxShadow: "var(--shadow-pop)",
			animation: "cnPop var(--dur) ease",
			...u
		},
		children: [/* @__PURE__ */ r("div", {
			style: {
				display: "flex",
				alignItems: "center",
				gap: 9,
				padding: "11px 13px",
				borderBottom: "1px solid var(--border-subtle)"
			},
			children: [
				/* @__PURE__ */ n("span", { style: {
					width: 9,
					height: 9,
					background: o,
					flexShrink: 0,
					transform: "rotate(45deg)"
				} }),
				/* @__PURE__ */ r("div", {
					style: {
						flex: 1,
						minWidth: 0
					},
					children: [/* @__PURE__ */ n("div", {
						style: {
							fontSize: "var(--fs-body)",
							fontWeight: 600
						},
						children: e
					}), /* @__PURE__ */ n("div", {
						style: {
							fontFamily: "var(--font-mono)",
							fontSize: "var(--fs-2xs-2)",
							color: "var(--text-dim)"
						},
						children: t
					})]
				}),
				l && /* @__PURE__ */ n("button", {
					type: "button",
					"aria-label": "Close",
					onClick: l,
					style: {
						border: 0,
						background: "transparent",
						color: "var(--text-dim)",
						cursor: "pointer",
						fontSize: 16
					},
					children: "×"
				})
			]
		}), /* @__PURE__ */ r("div", {
			style: { padding: "11px 13px" },
			children: [/* @__PURE__ */ n("div", {
				style: {
					fontFamily: "var(--font-mono)",
					fontSize: "var(--fs-xs)",
					color: "var(--text-prose)",
					lineHeight: 1.5
				},
				children: a
			}), /* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					gap: 7,
					marginTop: 11
				},
				children: [/* @__PURE__ */ n(i, {
					variant: "accent",
					size: "sm",
					full: !0,
					onClick: c,
					children: s
				}), /* @__PURE__ */ n(i, {
					variant: "muted",
					size: "sm",
					full: !0,
					children: "Pin"
				})]
			})]
		})]
	});
}
// src/studio/TallyBadge.tsx
var F = {
	program: "PROGRAM",
	preview: "PREVIEW",
	onair: "ON AIR",
	live: "LIVE",
	idle: "IDLE"
}, I = {
	program: {
		color: "var(--alert-2)",
		border: "var(--alert)",
		glow: "var(--glow-alert)"
	},
	onair: {
		color: "var(--alert-2)",
		border: "var(--alert)",
		glow: "var(--glow-alert)"
	},
	live: {
		color: "var(--alert-2)",
		border: "var(--alert)",
		glow: "var(--glow-alert)"
	},
	preview: {
		color: "var(--preview)",
		border: "var(--preview)",
		glow: "0 0 8px var(--preview-glow)"
	},
	idle: {
		color: "var(--text-dim)",
		border: "var(--border)",
		glow: void 0
	}
}, L = {
	sm: {
		dot: 6,
		fontSize: "var(--fs-3xs)",
		pad: "3px 8px",
		gap: 5
	},
	md: {
		dot: 8,
		fontSize: "var(--fs-2xs)",
		pad: "4px 11px",
		gap: 7
	}
};
function R({ state: e, pulse: t = !1, label: i, size: a = "md" }) {
	let o = I[e], s = L[a], c = i ?? F[e];
	return /* @__PURE__ */ r("span", {
		role: "status",
		style: {
			display: "inline-flex",
			alignItems: "center",
			gap: s.gap,
			padding: s.pad,
			borderRadius: "var(--radius-pill)",
			background: "var(--well)",
			border: `1px solid ${o.border}`,
			lineHeight: 1,
			whiteSpace: "nowrap",
			verticalAlign: "middle"
		},
		children: [/* @__PURE__ */ n("span", {
			"aria-hidden": "true",
			style: {
				width: s.dot,
				height: s.dot,
				flex: "none",
				borderRadius: "var(--radius-dot)",
				background: o.color,
				boxShadow: o.glow,
				animation: t ? "cavePulse 1.4s ease-in-out infinite" : void 0
			}
		}), /* @__PURE__ */ n("span", {
			style: {
				fontFamily: "var(--font-display)",
				fontSize: s.fontSize,
				fontWeight: 600,
				letterSpacing: "var(--ls-caps)",
				textTransform: "uppercase",
				fontVariantNumeric: "tabular-nums",
				color: o.color
			},
			children: c
		})]
	});
}
// src/studio/TakeBar.tsx
var z = [
	{
		ms: 200,
		label: "0.2s"
	},
	{
		ms: 500,
		label: "0.5s"
	},
	{
		ms: 1e3,
		label: "1.0s"
	}
], B = [
	{
		value: "cut",
		label: "Cut"
	},
	{
		value: "dissolve",
		label: "Dissolve"
	},
	{
		value: "wipe",
		label: "Wipe"
	},
	{
		value: "slide",
		label: "Slide"
	}
];
function V() {
	return /* @__PURE__ */ r("svg", {
		width: "15",
		height: "15",
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		children: [/* @__PURE__ */ n("path", {
			d: "M4 12h13",
			stroke: "currentColor",
			strokeWidth: "2.5",
			strokeLinecap: "round"
		}), /* @__PURE__ */ n("path", {
			d: "M12 6l6 6-6 6",
			stroke: "currentColor",
			strokeWidth: "2.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	});
}
function H({ active: t, label: r, onSelect: i }) {
	let [a, o] = e.useState(!1);
	return /* @__PURE__ */ n("button", {
		type: "button",
		"aria-pressed": t,
		onClick: i,
		onMouseEnter: () => o(!0),
		onMouseLeave: () => o(!1),
		style: {
			flex: 1,
			font: "inherit",
			fontFamily: "var(--font-display)",
			fontVariantNumeric: "tabular-nums",
			fontSize: "var(--fs-xs)",
			fontWeight: t ? 700 : 500,
			letterSpacing: "var(--ls-label)",
			color: t ? "var(--gold-2)" : a ? "var(--text)" : "var(--text-muted)",
			background: t ? "var(--well)" : "var(--surface-btn)",
			border: "1px solid " + (t ? "var(--gold)" : a ? "var(--border-hover)" : "var(--border)"),
			borderRadius: "var(--radius)",
			padding: "5px 0",
			cursor: "pointer",
			transition: "border-color var(--dur-fast), color var(--dur-fast)"
		},
		children: r
	});
}
function U({ transitionType: t, onTransitionChange: a, durationMs: o, onDurationChange: s, tbar: l, onCut: u, onAuto: d, onFadeToBlack: f, onTake: p, taking: m = !1, ftbActive: h = !1 }) {
	let [g, _] = e.useState(!1), v = e.useId(), y = Math.round(Math.min(1, Math.max(0, l.value)) * 100), b = (e) => {
		let t = Math.min(1, Math.max(0, e));
		l.onChange(t), t >= 1 && l.onCommit();
	}, x = m ? "Taking to program" : h ? "Fade to black active — program is black" : "Ready", S = {
		fontFamily: "var(--font-sans)",
		fontSize: "var(--fs-2xs)",
		fontWeight: 600,
		color: "var(--text-label)",
		textTransform: "uppercase",
		letterSpacing: "var(--ls-label)"
	};
	return /* @__PURE__ */ r("section", {
		role: "group",
		"aria-label": "Take and transitions",
		style: {
			display: "flex",
			flexDirection: "column",
			gap: 14,
			width: 168,
			padding: 14,
			borderRadius: "var(--radius-lg)",
			background: "var(--surface-raised)",
			border: "1px solid var(--border)"
		},
		children: [
			/* @__PURE__ */ r("div", {
				role: "group",
				"aria-label": "Take actions",
				style: {
					display: "flex",
					gap: 6
				},
				children: [
					/* @__PURE__ */ n(i, {
						variant: "accent",
						onClick: u,
						style: {
							flex: 1,
							textAlign: "center"
						},
						children: "CUT"
					}),
					/* @__PURE__ */ n(i, {
						variant: "accent",
						onClick: d,
						style: {
							flex: 1,
							textAlign: "center"
						},
						children: "AUTO"
					}),
					/* @__PURE__ */ r("button", {
						type: "button",
						"aria-pressed": h,
						onClick: f,
						onMouseEnter: () => _(!0),
						onMouseLeave: () => _(!1),
						style: {
							flex: 1,
							display: "inline-flex",
							alignItems: "center",
							justifyContent: "center",
							gap: 5,
							font: "inherit",
							fontSize: "var(--fs-xs)",
							fontFamily: "var(--font-sans)",
							fontWeight: "var(--fw-bold)",
							letterSpacing: "var(--ls-label)",
							color: "var(--alert-2)",
							background: "var(--surface-btn)",
							border: "1px solid var(--alert)",
							borderRadius: "var(--radius)",
							padding: "7px 6px",
							cursor: "pointer",
							boxShadow: h || g ? "var(--glow-alert)" : "none",
							transition: "box-shadow var(--dur-fast)"
						},
						children: [h && /* @__PURE__ */ n("span", {
							"aria-hidden": "true",
							style: {
								width: 7,
								height: 7,
								borderRadius: "50%",
								background: "var(--alert-2)",
								boxShadow: "var(--glow-alert)",
								animation: "cavePulse 1.4s ease-in-out infinite"
							}
						}), "FTB"]
					})
				]
			}),
			/* @__PURE__ */ n(c, {
				label: "Transition",
				value: t,
				onChange: (e) => a(e),
				options: B,
				full: !0
			}),
			/* @__PURE__ */ r("div", { children: [/* @__PURE__ */ n("span", {
				id: v,
				style: {
					...S,
					display: "block",
					marginBottom: 5
				},
				children: "Auto-out"
			}), /* @__PURE__ */ n("div", {
				role: "group",
				"aria-labelledby": v,
				style: {
					display: "flex",
					gap: 6
				},
				children: z.map((e) => /* @__PURE__ */ n(H, {
					active: o === e.ms,
					label: e.label,
					onSelect: () => s(e.ms)
				}, e.ms))
			})] }),
			/* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					gap: 8,
					padding: "12px 0",
					borderRadius: "var(--radius-md)",
					background: "var(--well)",
					border: "1px solid var(--hairline)"
				},
				children: [
					/* @__PURE__ */ n("span", {
						style: S,
						children: "T-bar"
					}),
					/* @__PURE__ */ r("span", {
						"aria-hidden": "true",
						style: {
							fontFamily: "var(--font-display)",
							fontVariantNumeric: "tabular-nums",
							fontSize: "var(--fs-xs)",
							letterSpacing: "0.02em",
							color: y >= 100 ? "var(--alert-2)" : "var(--gold-2)"
						},
						children: [y, "%"]
					}),
					/* @__PURE__ */ n("input", {
						type: "range",
						min: 0,
						max: 1,
						step: .01,
						value: Math.min(1, Math.max(0, l.value)),
						"aria-label": "T-bar manual transition",
						"aria-orientation": "vertical",
						"aria-valuetext": `${y}% throw`,
						onChange: (e) => b(Number(e.target.value)),
						style: {
							writingMode: "vertical-lr",
							direction: "rtl",
							width: 22,
							height: 128,
							accentColor: "var(--gold)",
							cursor: "pointer"
						}
					})
				]
			}),
			/* @__PURE__ */ n("div", {
				"aria-busy": m || void 0,
				style: { marginTop: "auto" },
				children: /* @__PURE__ */ n(i, {
					variant: "gold",
					full: !0,
					disabled: m,
					onClick: p,
					children: /* @__PURE__ */ r("span", {
						style: {
							display: "inline-flex",
							alignItems: "center",
							justifyContent: "center",
							gap: 8
						},
						children: [/* @__PURE__ */ n(V, {}), m ? "Taking…" : "TAKE"]
					})
				})
			}),
			/* @__PURE__ */ n("p", {
				role: "status",
				"aria-live": "polite",
				style: {
					margin: 0,
					textAlign: "center",
					fontFamily: "var(--font-sans)",
					fontSize: "var(--fs-3xs)",
					letterSpacing: "var(--ls-label)",
					textTransform: "uppercase",
					color: h || m ? "var(--alert-2)" : "var(--text-muted)"
				},
				children: x
			})
		]
	});
}
// src/studio/Fader.tsx
function W({ off: e, loud: i }) {
	return /* @__PURE__ */ r("svg", {
		width: "16",
		height: "16",
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		children: [/* @__PURE__ */ n("path", {
			d: "M4 9h3l4-3v12l-4-3H4z",
			fill: "currentColor"
		}), e ? /* @__PURE__ */ r(t, { children: [/* @__PURE__ */ n("line", {
			x1: "16",
			y1: "9",
			x2: "21",
			y2: "14",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		}), /* @__PURE__ */ n("line", {
			x1: "21",
			y1: "9",
			x2: "16",
			y2: "14",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		})] }) : /* @__PURE__ */ r(t, { children: [/* @__PURE__ */ n("path", {
			d: "M15 9a4 4 0 0 1 0 6",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		}), i && /* @__PURE__ */ n("path", {
			d: "M17.6 6.6a7.5 7.5 0 0 1 0 10.8",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		})] })]
	});
}
var G = 168, K = "\n.lgds-fader__throw { -webkit-appearance: none; appearance: none; background: transparent; cursor: pointer; }\n.lgds-fader__throw:focus-visible { outline: none; }\n.lgds-fader__throw::-webkit-slider-runnable-track { width: 8px; border-radius: var(--radius-pill); background: var(--well); border: 1px solid var(--hairline); }\n.lgds-fader__throw::-webkit-slider-thumb { -webkit-appearance: none; width: 26px; height: 13px; margin-left: -9px; border-radius: 4px; background: var(--grad-gold); border: 1px solid var(--gold-2); box-shadow: 0 2px 6px rgba(0,0,0,0.5); }\n.lgds-fader__throw:focus-visible::-webkit-slider-thumb { box-shadow: var(--glow-accent-ring); }\n.lgds-fader__throw::-moz-range-track { width: 8px; border-radius: var(--radius-pill); background: var(--well); border: 1px solid var(--hairline); }\n.lgds-fader__throw::-moz-range-thumb { width: 26px; height: 13px; border-radius: 4px; background: var(--gold); border: 1px solid var(--gold-2); box-shadow: 0 2px 6px rgba(0,0,0,0.5); }\n.lgds-fader__throw:focus-visible::-moz-range-thumb { box-shadow: var(--glow-accent-ring); }\n";
function q({ label: t, value: i, onChange: a, muted: o, onMutedChange: s, level: c = 0, master: l = !1, dbReadout: u }) {
	let d = e.useId(), f = Math.min(1, Math.max(0, i)), p = Math.round(f * 100), m = Math.round(Math.min(1, Math.max(0, c)) * 100), h = (e) => {
		let t = Math.min(1, Math.max(0, e));
		a(t), t > 0 && o && s(!1);
	};
	return /* @__PURE__ */ r("div", {
		role: "group",
		"aria-labelledby": d,
		style: {
			position: "relative",
			display: "flex",
			flexDirection: "column",
			alignItems: "center",
			gap: 8,
			width: 76,
			padding: "10px 8px 9px",
			borderRadius: "var(--radius-lg)",
			overflow: "hidden",
			background: l ? "var(--surface-raised)" : "var(--surface-quiet)",
			border: `1px solid ${l ? "var(--border-strong)" : "var(--hairline)"}`,
			boxShadow: l ? "var(--shadow-raised)" : "none"
		},
		children: [
			/* @__PURE__ */ n("style", { children: K }),
			l && /* @__PURE__ */ n("span", {
				"aria-hidden": !0,
				style: {
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					height: 1,
					background: "linear-gradient(90deg, transparent, var(--accent-glow), transparent)"
				}
			}),
			/* @__PURE__ */ n("span", {
				style: {
					minHeight: 14,
					fontFamily: "var(--font-display)",
					fontSize: "var(--fs-2xs)",
					fontVariantNumeric: "tabular-nums",
					letterSpacing: "var(--ls-label)",
					color: u ? "var(--text-2)" : "transparent",
					lineHeight: 1
				},
				children: u ?? "\xA0"
			}),
			/* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					alignItems: "stretch",
					gap: 8,
					height: G
				},
				children: [/* @__PURE__ */ n("div", {
					"aria-hidden": "true",
					style: {
						position: "relative",
						width: 6,
						height: "100%",
						borderRadius: "var(--radius-pill)",
						background: "var(--well)",
						border: "1px solid var(--hairline)",
						overflow: "hidden"
					},
					children: /* @__PURE__ */ n("div", { style: {
						position: "absolute",
						left: 0,
						right: 0,
						bottom: 0,
						height: `${m}%`,
						background: "linear-gradient(to top, var(--preview), var(--alert))",
						transition: "height 90ms linear"
					} })
				}), /* @__PURE__ */ n("input", {
					className: "lgds-fader__throw",
					type: "range",
					min: 0,
					max: 1,
					step: .02,
					value: f,
					"aria-label": `${t} volume`,
					"aria-orientation": "vertical",
					"aria-valuetext": `${p}%`,
					onChange: (e) => h(Number(e.target.value)),
					style: {
						writingMode: "vertical-lr",
						direction: "rtl",
						height: "100%",
						width: 26,
						margin: 0
					}
				})]
			}),
			/* @__PURE__ */ n("button", {
				type: "button",
				"aria-label": o ? "Unmute" : "Mute",
				"aria-pressed": o,
				onClick: () => s(!o),
				style: {
					display: "inline-flex",
					alignItems: "center",
					justifyContent: "center",
					width: 40,
					height: 30,
					padding: 0,
					borderRadius: "var(--radius)",
					background: o ? "var(--alert-tint)" : "var(--surface-btn)",
					border: `1px solid ${o ? "var(--alert)" : "var(--border)"}`,
					boxShadow: o ? "var(--glow-alert)" : "none",
					color: o ? "var(--alert-2)" : f <= 0 ? "var(--text-dim)" : "var(--gold)",
					cursor: "pointer",
					transition: "color var(--dur-fast), border-color var(--dur-fast)"
				},
				children: /* @__PURE__ */ n(W, {
					off: o,
					loud: !o && f > .5
				})
			}),
			/* @__PURE__ */ n("span", {
				role: "status",
				"aria-live": "polite",
				style: {
					minHeight: 11,
					fontFamily: "var(--font-sans)",
					fontSize: "var(--fs-3xs)",
					fontWeight: 700,
					textTransform: "uppercase",
					letterSpacing: "var(--ls-caps)",
					color: "var(--alert-2)",
					lineHeight: 1
				},
				children: o ? "Muted" : ""
			}),
			/* @__PURE__ */ n("span", {
				id: d,
				style: {
					fontFamily: "var(--font-display)",
					fontSize: "var(--fs-2xs)",
					fontWeight: 600,
					textTransform: "uppercase",
					letterSpacing: "var(--ls-caps)",
					color: l ? "var(--gold-2)" : "var(--text-hi)",
					textAlign: "center",
					lineHeight: 1.15,
					maxWidth: "100%",
					overflow: "hidden",
					textOverflow: "ellipsis",
					whiteSpace: "nowrap"
				},
				children: t
			})
		]
	});
}
// src/studio/WorkspaceTabStrip.tsx
function J({ tabs: e, active: t, onChange: i, showLabel: a, navLabel: o = "Studio workspace" }) {
	return /* @__PURE__ */ r("div", {
		style: {
			display: "flex",
			alignItems: "stretch",
			gap: 8,
			minWidth: 0,
			background: "var(--surface-quiet)",
			borderBottom: "1px solid var(--border-strong)"
		},
		children: [/* @__PURE__ */ n("nav", {
			"aria-label": o,
			style: {
				display: "flex",
				alignItems: "stretch",
				flex: 1,
				minWidth: 0,
				overflowX: "auto",
				overflowY: "hidden"
			},
			children: e.map((e) => /* @__PURE__ */ n("div", {
				style: { flex: "0 0 auto" },
				children: /* @__PURE__ */ n(p, {
					label: e.label,
					active: e.id === t,
					onClick: () => i(e.id)
				})
			}, e.id))
		}), a != null && /* @__PURE__ */ n("div", {
			style: {
				display: "flex",
				alignItems: "center",
				flex: "0 0 auto",
				paddingLeft: 12,
				paddingRight: 13,
				borderLeft: "1px solid var(--hairline)",
				fontFamily: "var(--font-display)",
				fontVariantNumeric: "tabular-nums"
			},
			children: a
		})]
	});
}
// src/studio/StudioPanel.tsx
var Y = {
	fontFamily: "var(--font-sans)",
	fontSize: "var(--fs-2xs)",
	fontWeight: 600,
	color: "var(--gold)",
	textTransform: "uppercase",
	letterSpacing: "var(--ls-label-wider)",
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis"
};
function X({ title: e, tier: t = "base", status: i, actions: a, scroll: o = !1, ariaLabel: s, children: c }) {
	let l = e != null || i != null || a != null;
	return /* @__PURE__ */ r(b, {
		tier: t,
		"aria-label": s,
		style: {
			padding: 0,
			display: "flex",
			flexDirection: "column",
			minHeight: 0,
			...o ? { overflow: "hidden" } : null
		},
		children: [l && /* @__PURE__ */ r("div", {
			style: {
				display: "flex",
				alignItems: "center",
				gap: 9,
				padding: "9px 12px",
				borderBottom: "1px solid var(--hairline)",
				flexShrink: 0
			},
			children: [
				/* @__PURE__ */ r("div", {
					style: {
						display: "flex",
						alignItems: "center",
						gap: 8,
						minWidth: 0
					},
					children: [e != null && /* @__PURE__ */ n("span", {
						style: Y,
						children: e
					}), i != null && /* @__PURE__ */ n("span", {
						style: {
							display: "inline-flex",
							alignItems: "center",
							flexShrink: 0
						},
						children: i
					})]
				}),
				/* @__PURE__ */ n("span", {
					"aria-hidden": !0,
					style: {
						flex: 1,
						height: 1,
						minWidth: 8,
						background: "linear-gradient(90deg, var(--border), transparent)"
					}
				}),
				a != null && /* @__PURE__ */ n("div", {
					style: {
						display: "flex",
						alignItems: "center",
						gap: 6,
						flexShrink: 0
					},
					children: a
				})
			]
		}), /* @__PURE__ */ n("div", {
			tabIndex: o ? 0 : void 0,
			style: {
				padding: 12,
				...o ? {
					flex: 1,
					minHeight: 0,
					overflowY: "auto"
				} : null
			},
			children: c
		})]
	});
}
// src/studio/MonitorFrame.tsx
var Z = {
	program: {
		border: "var(--alert-2)",
		glow: "var(--glow-alert)",
		badge: "onair"
	},
	preview: {
		border: "var(--preview)",
		glow: "0 0 10px var(--preview-glow)",
		badge: "preview"
	},
	none: {
		border: "var(--hairline)",
		glow: void 0
	}
}, Q = {
	display: "inline-flex",
	alignItems: "center",
	maxWidth: "100%",
	padding: "3px 8px",
	borderRadius: "var(--radius-sm)",
	background: "var(--bg-rail)",
	border: "1px solid var(--hairline)",
	fontFamily: "var(--font-display)",
	fontSize: "var(--fs-2xs)",
	fontWeight: 600,
	letterSpacing: "var(--ls-caps)",
	textTransform: "uppercase",
	fontVariantNumeric: "tabular-nums",
	color: "var(--text-hi)",
	lineHeight: 1,
	whiteSpace: "nowrap",
	overflow: "hidden",
	textOverflow: "ellipsis"
};
function $({ tally: e, label: t, bug: i, lowerThird: a, ticker: o, children: s, ariaLabel: c }) {
	let l = Z[e], u = typeof t == "string" || typeof t == "number" ? String(t) : void 0, d = e === "program" ? "Program" : e === "preview" ? "Preview" : "", f = c ?? (u ? d ? `${d} monitor: ${u}` : `Monitor: ${u}` : d ? `${d} monitor` : "Video monitor"), p = t != null || l.badge != null;
	return /* @__PURE__ */ r("div", {
		role: "img",
		"aria-label": f,
		style: {
			position: "relative",
			width: "100%",
			aspectRatio: "16 / 9",
			borderRadius: "var(--radius-md)",
			overflow: "hidden",
			background: "var(--well)",
			border: `2px solid ${l.border}`,
			boxShadow: l.glow,
			fontFamily: "var(--font-sans)"
		},
		children: [
			/* @__PURE__ */ n("div", {
				"data-region": "video",
				style: {
					position: "absolute",
					inset: 0,
					zIndex: 0,
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					overflow: "hidden"
				},
				children: s
			}),
			a != null && /* @__PURE__ */ n("div", {
				"data-region": "lower-third",
				style: {
					position: "absolute",
					left: 0,
					right: 0,
					bottom: 0,
					zIndex: 2
				},
				children: a
			}),
			o != null && /* @__PURE__ */ n("div", {
				"data-region": "ticker",
				style: {
					position: "absolute",
					left: 0,
					right: 0,
					bottom: 0,
					zIndex: 3
				},
				children: o
			}),
			i != null && /* @__PURE__ */ n("div", {
				"data-region": "bug",
				style: {
					position: "absolute",
					top: 8,
					right: 8,
					zIndex: 3
				},
				children: i
			}),
			p && /* @__PURE__ */ r("div", {
				"data-region": "label",
				style: {
					position: "absolute",
					top: 8,
					left: 8,
					zIndex: 4,
					display: "flex",
					alignItems: "center",
					gap: 6,
					maxWidth: "calc(100% - 16px)"
				},
				children: [t != null && /* @__PURE__ */ n("span", {
					style: Q,
					children: t
				}), l.badge != null && /* @__PURE__ */ n(R, {
					state: l.badge,
					size: "sm",
					pulse: l.badge === "onair"
				})]
			})
		]
	});
}
// src/studio/StudioTopBar.tsx
function te(e) {
	let t = Number.isFinite(e) && e > 0 ? Math.floor(e / 1e3) : 0, n = Math.floor(t / 3600), r = Math.floor(t % 3600 / 60), i = t % 60, a = (e) => String(e).padStart(2, "0");
	return `${n}:${a(r)}:${a(i)}`;
}
function ne() {
	return /* @__PURE__ */ r("span", {
		style: {
			display: "inline-flex",
			alignItems: "center",
			gap: 8
		},
		children: [/* @__PURE__ */ r("svg", {
			width: "18",
			height: "18",
			viewBox: "0 0 24 24",
			fill: "none",
			"aria-hidden": "true",
			focusable: "false",
			children: [/* @__PURE__ */ n("path", {
				d: "M12 3l8 5v8l-8 5-8-5V8z",
				stroke: "var(--gold)",
				strokeWidth: "1.6",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ n("path", {
				d: "M12 8l4 2.5v3L12 16l-4-2.5v-3z",
				fill: "var(--gold)"
			})]
		}), /* @__PURE__ */ n("span", {
			style: {
				fontFamily: "var(--font-display)",
				fontSize: "var(--fs-lg)",
				fontWeight: 600,
				color: "var(--gold-2)",
				textTransform: "uppercase",
				letterSpacing: "var(--ls-caps)",
				lineHeight: 1
			},
			children: "Studio"
		})]
	});
}
function re({ brand: a, showLabel: o, onAir: s, elapsedMs: c, encoderStats: l, destinations: u, endLabel: d = "End stream", onEndStream: f, endBusy: p = !1, endError: m, status: h }) {
	let [g, _] = e.useState(!1), v = c == null ? null : te(c);
	return /* @__PURE__ */ r("header", {
		"aria-label": "Studio",
		style: {
			display: "flex",
			alignItems: "center",
			gap: 14,
			height: 44,
			padding: "0 12px",
			background: "var(--bg-rail)",
			borderBottom: "1px solid var(--border-strong)",
			backdropFilter: "var(--blur-nav)",
			WebkitBackdropFilter: "var(--blur-nav)",
			boxSizing: "border-box"
		},
		children: [
			/* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					alignItems: "center",
					gap: 12,
					flex: "none"
				},
				children: [
					a ?? /* @__PURE__ */ n(ne, {}),
					o != null && /* @__PURE__ */ r(t, { children: [/* @__PURE__ */ n("span", {
						"aria-hidden": "true",
						style: {
							width: 1,
							height: 20,
							background: "var(--hairline)"
						}
					}), /* @__PURE__ */ n("span", {
						style: {
							fontFamily: "var(--font-sans)",
							fontSize: "var(--fs-sm)",
							fontWeight: 600,
							color: "var(--text)",
							whiteSpace: "nowrap",
							overflow: "hidden",
							textOverflow: "ellipsis",
							maxWidth: 220
						},
						children: o
					})] }),
					/* @__PURE__ */ n(R, {
						state: s ? "onair" : "idle",
						pulse: s,
						size: "sm"
					}),
					v != null && /* @__PURE__ */ n("span", {
						role: "timer",
						"aria-label": `Elapsed time ${v}`,
						style: {
							fontFamily: "var(--font-display)",
							fontSize: "var(--fs-lg)",
							fontWeight: 600,
							color: s ? "var(--gold-2)" : "var(--text-muted)",
							fontVariantNumeric: "tabular-nums",
							fontFeatureSettings: "\"tnum\" 1",
							letterSpacing: "var(--ls-tight)",
							lineHeight: 1
						},
						children: v
					})
				]
			}),
			/* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					alignItems: "center",
					gap: 16,
					flex: "1 1 auto",
					minWidth: 0,
					overflow: "hidden"
				},
				children: [l != null && l.length > 0 && /* @__PURE__ */ n("ul", {
					"aria-label": "Encoder stats",
					style: {
						display: "flex",
						alignItems: "center",
						gap: 16,
						margin: 0,
						padding: 0,
						listStyle: "none",
						minWidth: 0,
						overflow: "hidden"
					},
					children: l.map((e, t) => /* @__PURE__ */ r("li", {
						style: {
							display: "inline-flex",
							alignItems: "baseline",
							gap: 5,
							whiteSpace: "nowrap"
						},
						children: [/* @__PURE__ */ n("span", {
							style: {
								fontFamily: "var(--font-display)",
								fontSize: "var(--fs-sm)",
								fontWeight: 600,
								color: "var(--text)",
								fontVariantNumeric: "tabular-nums",
								fontFeatureSettings: "\"tnum\" 1",
								lineHeight: 1
							},
							children: e.value
						}), /* @__PURE__ */ n("span", {
							style: {
								fontFamily: "var(--font-sans)",
								fontSize: "var(--fs-3xs)",
								fontWeight: 600,
								color: "var(--text-dim)",
								textTransform: "uppercase",
								letterSpacing: "var(--ls-label)",
								lineHeight: 1
							},
							children: e.label
						})]
					}, `${e.label}-${t}`))
				}), h != null && /* @__PURE__ */ n("div", {
					style: {
						minWidth: 0,
						overflow: "hidden",
						fontSize: "var(--fs-sm)",
						color: "var(--text-muted)"
					},
					children: h
				})]
			}),
			/* @__PURE__ */ r("div", {
				style: {
					display: "flex",
					alignItems: "center",
					gap: 12,
					flex: "none",
					marginLeft: "auto"
				},
				children: [u != null && /* @__PURE__ */ n("div", {
					style: {
						display: "flex",
						alignItems: "center",
						gap: 8
					},
					children: u
				}), /* @__PURE__ */ n(i, {
					variant: "default",
					size: "sm",
					onClick: () => _(!0),
					style: {
						borderColor: "var(--alert)",
						color: "var(--alert-2)",
						textTransform: "uppercase",
						letterSpacing: "var(--ls-label)",
						fontWeight: "var(--fw-bold)"
					},
					children: d
				})]
			}),
			g && /* @__PURE__ */ n(N, {
				title: `${d}?`,
				destructive: !0,
				confirmLabel: d,
				cancelLabel: "Keep streaming",
				busy: p,
				error: m,
				onCancel: () => _(!1),
				onConfirm: f,
				children: "This ends the live broadcast for everyone watching. The stream can't be resumed once it's ended."
			})
		]
	});
}
// src/studio/DualBusMonitor.tsx
function ie({ preview: e, program: t, takeColumn: i, previewLabel: a, programLabel: o, programBug: s, programLowerThird: c, programTicker: l, stacked: u = !1 }) {
	return /* @__PURE__ */ r("div", {
		role: "group",
		"aria-label": "Program and preview monitors",
		"data-stacked": u || void 0,
		style: {
			display: "grid",
			gridTemplateColumns: u ? "minmax(0, 1fr)" : "minmax(0, 1fr) auto minmax(0, 1fr)",
			alignItems: "center",
			justifyItems: u ? "center" : "stretch",
			gap: u ? 12 : 14,
			width: "100%",
			fontFamily: "var(--font-sans)"
		},
		children: [
			/* @__PURE__ */ n("div", {
				"data-bus": "preview",
				style: {
					minWidth: 0,
					width: "100%"
				},
				children: /* @__PURE__ */ n($, {
					tally: "preview",
					label: a,
					children: e
				})
			}),
			/* @__PURE__ */ n("div", {
				"data-bus": "take",
				style: {
					display: "flex",
					alignItems: "stretch",
					justifyContent: "center",
					flex: "0 0 auto"
				},
				children: i
			}),
			/* @__PURE__ */ n("div", {
				"data-bus": "program",
				style: {
					minWidth: 0,
					width: "100%"
				},
				children: /* @__PURE__ */ n($, {
					tally: "program",
					label: o,
					bug: s,
					lowerThird: c,
					ticker: l,
					children: t
				})
			})
		]
	});
}
export { g as AppShell, i as Button, f as CaseTab, S as Chip, N as ConfirmDialog, A as ConflictBanner, j as ConflictPicker, C as ContextMark, a as DiamondCheckbox, ie as DualBusMonitor, w as EventBlock, q as Fader, v as FullscreenShell, d as IconRailItem, P as InspectorCard, ee as LegendHeadshot, T as LoadSparkline, $ as MonitorFrame, m as NavItem, E as NodePill, D as OutlineRow, b as Panel, o as SearchField, c as Select, h as SidebarNav, x as StatGrid, X as StudioPanel, re as StudioTopBar, U as TakeBar, R as TallyBadge, O as TaskRow, s as TextField, p as ViewTab, u as VolumeControl, J as WorkspaceTabStrip };

//# sourceMappingURL=legends-ui.js.map